import React from "react"
import TextInput from "./text-input"

interface ColorPickerInputProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
    label?: string,
    message?: string,
    error?: boolean,
    clearable?: boolean,
    onChange: (value: string) => void
}

// Native colour inputs always render a swatch, so an unset field shows this instead of
// looking like the department was deliberately assigned black.
const UNSET_SWATCH = "#ffffff"

const ColorPickerInput: React.FC<ColorPickerInputProps> = ({
    label,
    value,
    message,
    required,
    error,
    className,
    clearable,
    onChange,
    ...inputProps
}) => {
    const hex = (value as string) ?? ""

    return (
        <div className={`input-container ${error ? 'error' : ''} ${className ?? ''}`}>
            {label && <span className="input-label">{label}{required && "*"}</span>}
            <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>
                <input
                    type="color"
                    className="input"
                    value={hex || UNSET_SWATCH}
                    required={required}
                    onChange={(e) => onChange(e.target.value)}
                    style={{ width: '48px', flexShrink: 0, padding: '2px', cursor: 'pointer' }}
                />
                <TextInput
                    {...inputProps}
                    placeholder="#1A2B3C"
                    value={hex}
                    onChange={(e) => onChange(e.target.value)}
                />
                {clearable && hex &&
                    <span
                        onClick={() => onChange("")}
                        style={{ cursor: 'pointer', flexShrink: 0, padding: '0 4px' }}
                    >
                        ✕
                    </span>
                }
            </div>
            {message && <span className="input-message">{message}</span>}
        </div>
    )
}

export default ColorPickerInput
